import IziToast from 'izitoast'
import Quill from 'quill'
import Sortable from 'sortablejs'
import {ArgumentError, InternalError} from './error'
import Helper from './helper'
import Is from './is'
import Moment from 'daterangepicker/moment.min'
import Log from './log'

// noinspection JSUnusedGlobalSymbols

export default class Ui
{
	static init()
	{
		Ui.load('date-picker')
		Ui.load('datetime-picker')
		Ui.load('time-picker')
		Ui.load('daterange-picker')
		Ui.load('select-picker')
		Ui.load('input-file')
		Ui.load('input-file-image')
		Ui.load('text-editor')
		Ui.load('text-editor-ck')

		Ui.load('text-truncate')
		Ui.load('text-tooltip')

		Ui.load('table-sorter')
		Ui.load('table-link-cell')
		Ui.load('table-filter')
		Ui.load('table-order')
		Ui.load('table-sticky-header')

		Ui.load('image-gallery')
		Ui.load('draggable')

		Ui.load('show-filter')
		Ui.load('lazy-load')

		Ui.scroll()
	}

	static _dismiss_second = 10

	static _success_timeout = 5

	static _notify_layout = {
		layout             : 2,
		position           : 'topRight',
		progressBar        : false,
		transitionOutMobile: 'fadeOutUp',
	}

	static success(message)
	{
		IziToast.success(Object.assign(this._notify_layout, {
			message: message,
			timeout: this._success_timeout * 1000,
			close  : false,
		}))
	}

	static info(message)
	{
		IziToast.info(Object.assign(this._notify_layout, {
			message: message,
			timeout: this._success_timeout * 1000,
			close  : false,
		}))
	}

	static warning(message)
	{
		IziToast.warning(Object.assign(this._notify_layout, {
			message: message,
			close  : true,
			timeout: false,
		}))
	}

	static error(message)
	{
		IziToast.error(Object.assign(this._notify_layout, {
			message: message,
			close  : true,
			timeout: false,
		}))
	}

	static _indicator = null

	static indicator(on)
	{
		if(this._indicator === null)
		{
			this._indicator = document.createElement('div')
			this._indicator.className = 'loader loader-bouncing'

			document.body.appendChild(this._indicator)
		}

		if(on) $(this._indicator).addClass('is-active')
		else $(this._indicator).removeClass('is-active')
	}

	static confirm(type)
	{
		let message = undefined

		switch(type)
		{
			case 'submit' :
				message = '更新しますか？'
			break

			case 'remove' :
				message = '削除しますか？'
			break

			case 'logout' :
				message = 'ログアウトしますか？'
			break
		}

		if(message === undefined) throw new InternalError(`不正なメッセージ種別です`)
		return confirm(message)
	}

	static post(url, data, callback = undefined, timeout_second = 10)
	{
		(async () =>
		{
			const result = {
				message: '(メッセージが指定されていません)',
				success: false,
			}

			try
			{
				const response = await $.ajax({
					method : 'POST',
					url    : url,
					data   : data,
					timeout: timeout_second * Helper.unit.millisecond,
				})

				result.success = response.success
				if(!response.success) throw new InternalError(response.message || result.message)

				result.message = response.message
			}
			catch(exception)
			{
				switch(exception.statusText)
				{
					case 'timeout' :
						result.message = '処理がタイムアウトしました'
					break

					default :
						result.message = exception.message || exception.statusText
						if(result.message === 'error') result.message = 'エラーが発生しました'
					break
				}

				result.success = false
			}
			finally
			{
				if(result.message !== null)
				{
					if(result.success) Ui.success(result.message)
					else Ui.error(result.message)
				}

				if(callback !== undefined) callback(result.success, result.message)
			}
		})()
	}

	static flip_password(selector)
	{
		const type = $(selector).attr('type')
		$(selector).attr('type', type === 'password' ? 'text' : 'password')
	}

	static load(type)
	{
		switch(type)
		{
			case 'table-sticky-header' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.ui-table-sticky-header').each((index, element) =>
					{
						$(element).floatThead()
					})
				})
			break

			case 'table-sorter' :
				Log.debug(`Running ${type}`, () =>
				{
					const table = $('.ui-table-sorter')
					const column = Is.int(table.data('sort-column')) ? Number(table.data('sort-column')) : 0

					table.tablesorter({
						sortList        : [[column, 1]],
						sortInitialOrder: 'desc',

						textExtraction: (node) =>
						{
							const value = $(node).attr('data-sort')
							return typeof value !== 'undefined' ? value : $(node).text()
						},
					})
				})
			break

			case 'table-order' :
				Log.debug(`Running ${type}`, () =>
				{
					const table = $('.ui-table-order')

					const key = table.data('order-key') || 'order'
					const key_reverse = table.data('order-key-reverse') || 'reverse'
					const key_page = table.data('order-key-page') || 'page'

					const match = new RegExp(`\\b${key}=([\\w.]+)`).exec(location.search)

					let ordered = match !== null ? match[1] : undefined
					const reversed = !location.search.match(new RegExp(`\\b${key_reverse}=0`))

					$('.ui-table-order thead th').each((index, element) =>
					{
						const cell = $(element)

						const name = cell.data('order')
						if(!name) return

						if(ordered === undefined) ordered = name

						cell.addClass('tablesorter-header')
						if(name === ordered) cell.addClass(reversed ? 'tablesorter-headerDesc' : 'tablesorter-headerAsc')

						cell.on('click', () =>
						{
							if(!Is.filled(name)) throw new ArgumentError('No name given to sort')
							const reverse = !cell.hasClass('tablesorter-headerDesc')

							cell.parent().find('th').each((index, element) =>
							{
								const cell = $(element)

								cell.removeClass('tablesorter-headerAsc')
								cell.removeClass('tablesorter-headerDesc')
							})

							if(reverse)
							{
								cell.removeClass('tablesorter-headerAsc')
								cell.addClass('tablesorter-headerDesc')
							}
							else
							{
								cell.removeClass('tablesorter-headerDesc')
								cell.addClass('tablesorter-headerAsc')
							}

							const query = location.search
								.replace(new RegExp(`[&?]${key}=[\\w.]*`), '')
								.replace(new RegExp(`[&?]${key_reverse}=[01]`), '')
								.replace(new RegExp(`[&?]${key_page}=\\d*`), '')

							const connector = query === '' ? '?' : '&'
							location.search = `${query}${connector}${key}=${name}&${key_reverse}=${reverse ? 1 : 0}`
						})
					})
				})
			break

			case 'table-link-cell' :
				Log.debug(`Running ${type}`, () =>
				{
					$('table.ui-table-link-cell tbody tr').each((index, row) =>
					{
						const link = $(row).attr('data-href')
						if(!link) return

						const row_element = $(row)

						row_element.find('> td:not(.no-link)').each((index2, cell) =>
						{
							if(cell.firstChild && cell.firstChild.nodeName === 'A')
							{
								cell.firstChild.style.display = 'inline-block'
								return
							}

							const cell_element = $(cell)
							const anchor = document.createElement('a')

							anchor.href = link
							anchor.className = 'link-anchor'

							if(cell_element.html().match(/^\s*$/)) cell_element.html('&nbsp;')
							cell_element.css('padding', '0')

							cell_element.contents().appendTo(anchor)
							$(anchor).appendTo(cell_element)
						})
					})

					$('table.ui-table-link-cell').css('display', 'table')
				})
			break

			case 'table-filter' :
				Log.debug(`Running ${type}`, () =>
				{
					window.LightTableFilter.init()
				})
			break

			case 'date-picker' :
				Log.debug(`Running ${type}`, () =>
				{
					$('input.ui-date-picker').each((index, element) =>
					{
						$(element).daterangepicker({
							locale          : {
								format    : 'YYYY-MM-DD',
								daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
								monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
							},
							autoApply       : true,
							autoUpdateInput : false,
							singleDatePicker: true,
							minYear         : 2021,
						})

						$(element).on('apply.daterangepicker', function(event, picker)
						{
							$(this).val(picker.startDate.format('YYYY-MM-DD'))
						})
					})
				})
			break

			case 'datetime-picker' :
				Log.debug(`Running ${type}`, () =>
				{
					const picker = $('input.ui-datetime-picker')

					picker.daterangepicker({
						locale          : {
							format     : 'YYYY-MM-DD HH:mm',
							daysOfWeek : ['日', '月', '火', '水', '木', '金', '土'],
							monthNames : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
							cancelLabel: 'キャンセル',
							applyLabel : '適用',
						},
						autoUpdateInput : false,
						singleDatePicker: true,
						timePicker      : true,
						timePicker24Hour: true,
						minYear         : 2021,
					})

					picker.on('apply.daterangepicker', function(event, picker)
					{
						$(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'))
					})
				})
			break

			case 'time-picker' :
				$('.ui-time-picker').timepicker({
					snapToStep  : true,
					minuteStep  : 5,
					showMeridian: false,
					defaultTime : false,
					icons       : {
						up  : 'fa fa-icon fa-chevron-up',
						down: 'fa fa-icon fa-chevron-down',
					},
				})
			break

			case 'daterange-picker' :
				Log.debug(`Running ${type}`, () =>
				{
					$('input.ui-daterange-picker').each((index, element) =>
					{
						// noinspection NonAsciiCharacters
						$(element).daterangepicker({
							startDate            : $(element).data('start'),
							endDate              : $(element).data('end'),
							ranges               : {
								'今日': [Moment(), Moment()],
								'昨日': [Moment().subtract(1, 'day'), Moment().subtract(1, 'day')],
								'今週': [Moment().startOf('week'), Moment().endOf('week')],
								'先週': [Moment().subtract(1, 'week').startOf('week'), Moment().subtract(1, 'week').endOf('week')],
								'今月': [Moment().startOf('month'), Moment().endOf('month')],
								'先月': [Moment().subtract(1, 'month').startOf('month'), Moment().subtract(1, 'month').endOf('month')],
							},
							'alwaysShowCalendars': true,
							locale               : {
								format          : 'YYYY-MM-DD',
								customRangeLabel: '期間指定',
								applyLabel      : '適用',
								cancelLabel     : 'キャンセル',
								daysOfWeek      : ['日', '月', '火', '水', '木', '金', '土'],
								monthNames      : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
							},
							minYear              : 2021,
						})
					})
				})
			break

			case 'select-picker' :
				Log.debug(`Running ${type}`, () =>
				{
					$('select:not([class="select-default"])').selectpicker({
						liveSearch      : true,
						noneSelectedText: '(未選択)',
						noneResultsText : '{0}の該当はありません',
						size            : 15,
					})
				})
			break

			case 'input-file' :
				Log.debug(`Running ${type}`, () =>
				{
					$('input[type="file"]:not([class="ui-input-file-image"])').filestyle({
						text        : ' 選択',
						btnClass    : 'btn-primary',
						badge       : true,
						buttonBefore: true,
						input       : false,
					})
				})
			break

			case 'input-file-image' :
				Log.debug(`Running ${type}`, () =>
				{
					const input_image = $('input[type="file"].ui-input-file-image')

					input_image.filestyle({
						text : '画像選択',
						badge: true,
						input: false,
					})

					$('.bootstrap-filestyle .buttonText').text('画像選択')

					input_image.each((index, input) =>
					{
						const preview = $(input).data('preview')
						if(!Is.filled(preview)) return

						const tag = document.querySelector(preview)
						if(!tag) return

						const original = tag.src

						input.addEventListener('change', function()
						{
							tag.src = this.files.length > 0 ? URL.createObjectURL(this.files[0]) : original

							const parent = tag.parentNode
							if(parent.nodeName === 'A') parent.href = tag.src
						})
					})
				})
			break

			case 'text-editor' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.ui-text-editor').each(function(index, element)
					{
						const Link = Quill.import('formats/link')

						class SameTargetLink extends Link
						{
							static create(value)
							{
								const node = Link.create(value)
								value = Link.sanitize(value)

								node.setAttribute('href', value)
								node.removeAttribute('target')

								return node
							}
						}

						Quill.register(SameTargetLink)

						new Quill(element, {
							modules: {
								toolbar: [
									[{'header': 1}, {'header': 2}],
									[{color: []}],
									['bold', 'italic', 'underline'],
									[{'list': 'ordered'}, {'list': 'bullet'}],
									['link'],
								],
							},
							theme  : 'snow',
						})

						$('.ui-text-editor').css('display', 'block')
					})
				})
			break

			case 'text-editor-ck' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.__editor').each((index, element) =>
					{
						// noinspection JSUnresolvedVariable
						ClassicEditor.create(element, {
							width: 'auto',
							image: {
								resizeUnit: 'px',
							},
							link : {
								decorators: {
									isExternal: {
										mode      : 'manual',
										label     : 'Open in a new tab',
										attributes: {
											target: '_blank',
										},
									},
								},
							},
						}).then(editor =>
						{
							$(element).data('editor', editor)
						})
					})
				})
			break

			case 'text-truncate' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.text-truncate').on('mouseenter', function()
					{
						const element = $(this)

						if(this.offsetWidth < this.scrollWidth)
						{
							element.tooltip({
								title: element.text(),
							})

							element.tooltip('show')
						}
					})
				})
			break

			case 'text-tooltip' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.ui-text-tooltip').tooltip()
				})
			break

			case 'image-gallery' :
				Log.debug(`Running ${type}`, () =>
				{
					const gallery = $('.ui-image-gallery')

					gallery.magnificPopup({
						type   : 'image',
						zoom   : {
							enabled: true,
							easing : 'ease-in-out',
						},
						gallery: {
							enabled : true,
							tPrev   : '前',
							tNext   : '次',
							tCounter: '%curr% / %total%',
							preload : [1, 1],
						},
						image  : {
							titleSrc: 'title',
							tError  : '画像がありません',
						},
					})

					gallery.on('mouseenter', (event) =>
					{
						document.createElement('img').src = event.currentTarget.href
					})
				})
			break

			case 'draggable' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.ui-draggable').each((index, element) =>
					{
						new Sortable(element, {})
					})
				})
			break

			case 'show-filter' :
				Log.debug(`Running ${type}`, () =>
				{
					$('.filter').css('visibility', 'visible')
				})
			break

			case 'lazy-load' :
				lazyload()
			break
		}
	}

	static is_mobile()
	{
		return window.matchMedia('only screen and (max-width: 767px)').matches
	}

	static _offset = 60

	static scroll()
	{
		$('a[href^="#"]').on('click', function(event)
		{
			event.preventDefault()

			const position = $($(this).attr('href')).offset().top - Ui._offset
			$('html, body').animate({scrollTop: position}, 'slow')
		})

		if(location.hash.match(/^#./))
		{
			$('html, body').animate({scrollTop: $(location.hash).offset().top - Ui._offset}, 'fast')
		}
	}

	static _timeout = 3

	static reload(success)
	{
		if(!success) return
		setTimeout(() => window.location.reload(), this._timeout * Helper.unit.millisecond)
	}
}
